<template>
  <v-popover class="multiple-actions-menu" trigger="manual" :open="showPopover">
    <div class="action-icon tooltip-target b3" @click.stop="showPopover = !showPopover"></div>
    <template slot="popover">
      <div
        v-for="action in options"
        :class="['action-item']"
        :key="action.event"
        @click.stop="onClick(action)"
        v-close-popover
      >
        <span :class="['action-icon', action.event]"></span>
        {{action.label}}
      </div>
    </template>
  </v-popover>
</template>

<script>

/*

USAGE:

  <MultipleActionsMenu :options="options" @onAction="callback"></MultipleActionsMenu> 

Props:
  options : Array of options and events like {label:'Copy', event:'copy'}
  onAction: Callback called when user select one of the options

*/

export default {
  name: 'MultipleActionsMenu',
  props: ['options'],
  data (){
    return {
      showPopover: false
    }
  },
  methods: {
    onClick(action) {
      this.$emit('onAction', action.event)
    }
  }
}
</script>

<style lang="stylus" scoped>
.multiple-actions-menu
  m-font-size(8, 9)

  .action-icon
    background-color: none
    background-image: url("~@/assets/icons/icon-dots-action.svg")
    background-position: center center
    background-repeat: no-repeat
    background-size: 12px 13px
    border-radius: 50%
    cursor: pointer
    height: 28px
    width: 28px
    margin-left: 5px
    &:hover
      background-color rgba($mystic, 0.5)

.action-item
  align-items: center
  cursor: pointer
  display: flex
  m-font-size(13, 16)
  padding: 10px

  &:hover
    background-color: $mystic

  &:not(:last-child)
    border-bottom: 1px solid $mystic
    // margin-bottom: 10px
    // padding-bottom: 10px

  .action-icon
    margin-right: 10px

    &.edit
      m-icon("edit", 15)

    &.close
      m-icon("close-lock", 15 12)

    &.open
      m-icon("open-lock", 15 12)

    &.cancel
      m-icon("trash", 15 12)

    &.duplicate
      m-icon("duplicate", 15 14)

    &.archive
      m-icon("archive", 15 14)

    &.unarchive
      m-icon("unarchive", 15 14)

    &.download
      m-icon("download", 15 14)
</style>>
